<div style="border-left: 5px solid rgb(207, 121, 1);;border-right: 5px solid rgb(207, 121, 1);" >

  <div class="backgroundTela">
    &nbsp;
  </div>

  <mat-tab-group [selectedIndex]="selectedIndex"  animationDuration="100ms" style="margin-left: 5px;">

    <!--MENU FICHAS -->
    <mat-tab *ngFor="let number of [0];let i=index;" label="📝 Cadastro Usuário  " >


      <form [formGroup]="formulario" novalidate>

        <!--Definir o tamanho da tela-->
        <div style=" width: 100%; overflow:hidden; text-align: center;">

          <div style="width: 100%; height: 60px; background-color: rgb(51, 68, 75); text-align: center;">

                <table style="width: 98%; ">

                  <tr>

                    <td style="width: 25%;">&nbsp;</td>

                    <td style="width: 20%;">
                      <mat-card style="padding: 0px; width: 98%;  height: 47px; margin: auto; margin-top: 5px;">
                        <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                          <mat-label style="text-align: left;">
                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                            <b> Forma de busca </b>
                          </mat-label>
                          <mat-select formControlName="formaBusca" (selectionChange)="onChangeBusca($event)"
                                       style="text-align: center; font-size: 12px; font-weight: 500;">
                            <mat-option value="empresa">Empresa</mat-option>
                            <mat-option value="re">RE</mat-option>
                            <mat-option value="nome">Nome</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-card>
                    </td>





                              <td style="width: 25%;" >

                                <mat-card *ngIf="this.formulario.controls['formaBusca'].value == 'empresa'"
                                    style="padding: 0px; width: 98%;  height: 47px; margin: auto; margin-top: 5px;">
                                  <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                                    <mat-label style="text-align: left;">
                                      <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> Operação</b>
                                      <i>(Empresa)</i>
                                    </mat-label>
                                    <mat-select formControlName="idOperacaoMenu"  (selectionChange)="limparListas(); "
                                                style="text-align: center; font-size: 12px; font-weight: 500;">
                                      <mat-option *ngFor="let colunas of lstCmbOperacao"
                                                  [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </mat-card>

                                <mat-card *ngIf="this.formulario.controls['formaBusca'].value == 're'"
                                  style="padding: 0px; width: 98%;  height: 47px; margin: auto; margin-top: 5px;">
                                  <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                                    <mat-label style="text-align: left;">
                                      <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> RE</b>
                                    </mat-label>
                                    <input matInput formControlName="reUsuario" placeholder="Ex. 1234" (keydown.enter)="buscarUsuarios()">
                                  </mat-form-field>
                                </mat-card>

                                <mat-card *ngIf="this.formulario.controls['formaBusca'].value == 'nome'"
                                  style="padding: 0px; width: 98%;  height: 47px; margin: auto; margin-top: 5px;">
                                  <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                                    <mat-label style="text-align: left;">
                                      <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> Nome</b>
                                    </mat-label>
                                    <input matInput formControlName="nomeUsuario" placeholder="Ex. Maria da Silva" style="font-size: 0.9rem;" (keydown.enter)="buscarUsuarios()">
                                  </mat-form-field>
                                </mat-card>

                                <mat-card *ngIf="this.formulario.controls['formaBusca'].value == ''"
                                  style="padding: 0px; width: 98%;  height: 47px; margin: auto; margin-top: 5px; background-color: rgb(212, 212, 212);">
                                  <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                                    <mat-label style="text-align: left;">
                                      <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> Selecione uma forma de busca</b>
                                    </mat-label>
                                    <input matInput disabled="true">
                                  </mat-form-field>
                                </mat-card>

                              </td>




                    <td style="width: 5%;" >
                      <div>
                        <button mat-raised-button type="button" style="background-color: rgb(207, 121, 1); color: #fff; margin-top: 5px;
                                                                        width: 98%; height:48px; font-size: 12px;" (click)="buscarUsuarios();">
                          <div style="margin-top: 0px;">
                            <img src="../../assets/img/icones/lupa.png" width="30px">&nbsp;&nbsp;
                          </div>

                        </button>
                      </div>
                    </td>
                    <td style="width: 25%;">&nbsp;</td>


                  </tr>

                </table>

          </div>
          <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

        </div>


        <div style="margin-top: 15px;">
          <!--container ajustado dinamicamente-->
          <div id="divContainer">

            <div id="divAdjustAutoHeight">

              <div style="margin-left: 5px; margin-right: 5px;">

              <!--DIV ESQUERDA-->
              <div id="formAndList">

                <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                  <div style=" margin-left: 15px; font-size: 14px; " *ngIf="formulario.controls.usuaIdUsuaCdUsuario.value == ''; else editarUsuario">Novo cadastro</div>
                  <ng-template #editarUsuario>
                    <div style=" margin-left: 15px; font-size: 14px; ">Editar cadastro</div>
                  </ng-template>
                </div>
                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                <mat-card class="mat-elevation-z8" style="padding: 8px;" >



                    <!--container ajustado dinamicamente-->
                    <div id="subDivContainer" style="width: 100%; ">
                        <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">

                          <input hidden matInput formControlName="usuaIdUsuaCdUsuario">

                          <table style="width: 100%;">
                            <tr>
                              <td style="width: 100%;" colspan="3">
                                <mat-form-field appearance="outline" >
                                  <mat-label>
                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                    <b> Tipo Usuário</b>
                                    <i>(Obrigatório)</i>
                                  </mat-label>
                                  <mat-select formControlName="tipoUsuario" >
                                    <mat-option *ngFor="let colunas of lstCmbTipoUsuario"
                                                [value]="colunas.tiusIdCdTipoUsuario">{{colunas.tiusDsTipoUsuario}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 100%;" colspan="3" *ngIf="formulario.controls.usuaIdUsuaCdUsuario.value == ''">
                                <mat-form-field  appearance="outline">
                                  <mat-label style="text-align: left;">
                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                    <b> Operação</b>
                                    <i>(Empresa)</i>
                                  </mat-label>

                                  <mat-select formControlName="idOperacao"  (selectionChange)="onChangeOperacao($event)">
                                    <mat-option *ngFor="let colunas of lstCmbOperacao"
                                                [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </td>
                            </tr>
                              <tr>
                                <td style="width: 100%;" colspan="3">
                                  <mat-form-field appearance="outline" *ngIf="formulario.controls.tipoUsuario.value == '3'">
                                    <mat-label>
                                      <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> Gestor</b>
                                    </mat-label>
                                    <mat-select formControlName="idGestor" >
                                      <mat-option *ngFor="let colunas of lstCmbGestao"
                                                  [value]="colunas.usuaIdCdUsuario">{{colunas.usuaNmUsuario}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </td>
                              </tr>
                              <tr>
                                <td style="width: 100%;" colspan="3">
                                  <mat-form-field appearance="outline" >
                                    <mat-label>
                                      <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> Nome</b>
                                      <i>(Obrigatório)</i>
                                    </mat-label>
                                    <input matInput formControlName="nome" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                  </mat-form-field>
                                </td>
                              </tr>
                              <tr>
                                <td style="width: 50%;">
                                  <div style="width: 100%;">
                                    <mat-form-field appearance="outline">
                                      <mat-label>
                                        <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                        <b> RE</b>
                                        <i>(Obrigatório)</i>
                                      </mat-label>
                                      <input matInput formControlName="re" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                    </mat-form-field>
                                  </div>
                                </td>
                                <td style="width: 50%;">
                                  <div style="width: 100%;" *ngIf="formulario.controls.tipoUsuario.value == 3">
                                    <mat-form-field appearance="outline">
                                      <mat-label>
                                        <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                        <b> Login DAC</b>
                                        <i>(Obrigatório)</i>
                                      </mat-label>
                                      <input matInput formControlName="loginDac" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                    </mat-form-field>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td style="width: 50%;">
                                  <div style="width: 100%;">
                                    <mat-form-field appearance="outline">
                                      <mat-label>
                                        <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                        <b> Situação</b>
                                        <i>(Obrigatório)</i>
                                      </mat-label>
                                      <mat-select formControlName="situacao" >
                                        <mat-option *ngFor="let colunas of lstCmbSituacao"
                                                    [value]="colunas.siusIdCdSituacaoUsuario">{{colunas.siusDsSituacao}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </td>
                                <td style="width: 50%;">
                                  <div style="width: 100%;">
                                    <mat-form-field appearance="outline" >
                                      <mat-label>
                                        <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                        <b> Carga Horária</b>
                                        <i>(Obrigatório)</i>
                                      </mat-label>
                                      <input matInput formControlName="cargaHoraria" type=time maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                    </mat-form-field>
                                  </div>
                                </td>
                              </tr>






                              <tr>
                                <td style="width: 50%;">
                                  <mat-form-field appearance="outline" style="width: 99%;">
                                    <mat-label> <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> Data Admissão</b>
                                      <i>(Obrigatório)</i>
                                    </mat-label>
                                    <input matInput [matDatepicker]="picker" readonly formControlName="dataAdmissao">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                  </mat-form-field>
                                </td>
                                <td style="width: 50%;">
                                  <mat-form-field appearance="outline" style="width: 99%;">
                                    <mat-label> <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> Data Inicio Operacional</b>
                                      <i>(Obrigatório)</i>
                                    </mat-label>
                                    <input matInput [matDatepicker]="picker2" readonly formControlName="dataInicioOperacional">
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                  </mat-form-field>
                                </td>
                              </tr>


                              <tr *ngIf="formulario.controls.isDesligado.value == true">
                               <td style="width: 50%;">
                                 &nbsp;
                                </td>
                                <td style="width: 50%;" >
                                  <mat-form-field appearance="outline" style="width: 99%;">
                                    <mat-label> <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                      <b> Data Desligamento</b>
                                      <i>(Obrigatório)</i>
                                    </mat-label>
                                    <input matInput [matDatepicker]="picker3" readonly formControlName="dataDesligamento" style="color:red; font-weight: bold; ">
                                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                    <mat-datepicker #picker3></mat-datepicker>
                                  </mat-form-field>
                                </td>
                              </tr>
                          </table>




                          <table style="width: 100%; text-align: center;">
                              <tr>
                                <td style="width: 33%; text-align: center;">
                                  <div style="width:100%; margin-top: 18px;">
                                    <mat-slide-toggle  style="font-size: 12px;" formControlName="isAdministrador" >Perfil Administrador?</mat-slide-toggle>
                                  </div>
                                </td>
                                <td style="width: 33%; text-align: center;">
                                  <div *ngIf="formulario.controls.usuaIdUsuaCdUsuario.value > 0"
                                    style="width:100%; margin-top: 18px;" >
                                    <mat-slide-toggle style="font-size: 12px; " formControlName="isInativo" >Cadastro inativo?</mat-slide-toggle>
                                  </div>
                                </td>
                                <td style="width: 33%; text-align: center;" >
                                  <div *ngIf="formulario.controls.usuaIdUsuaCdUsuario.value > 0"
                                    style="width:100%; margin-top: 18px;" >
                                    <mat-slide-toggle style="font-size: 12px;"  formControlName="isDesligado">Desligado?</mat-slide-toggle>
                                  </div>
                                </td><br>
                              </tr>
                              <tr>
                                <td style="width: 33%; text-align: center;">
                                  <div style="width:100%; margin-top: 18px;">
                                    <mat-slide-toggle  style="font-size: 12px;" formControlName="usuaInExcluirFicha" >Pode excluir monitoria?</mat-slide-toggle>
                                  </div>
                                </td>
                              </tr>
                          </table>

































                            <div style="width: 100%; margin-top: 05px;" *ngIf="formulario.controls.usuaIdUsuaCdUsuario.value == 0">

                              <div style="float: left; width: 69%; ">
                                <button mat-raised-button  type="button" (click)="add()"
                                  style="background-color: rgb(46, 163, 80); color: #fff; width: 99%; margin-top: 20px; font-size: 12px">
                                  Salvar
                                </button>
                              </div>

                              <div style="float: left; width: 30%; ">
                                <button mat-raised-button type="button" (click)="clearFormulario()" color="warn" style="color: #fff; width: 99%; margin-top: 20px; font-size: 12px ">
                                  Cancelar
                                </button>
                              </div>

                            </div>


                            <div style="width: 100%; " *ngIf="formulario.controls.usuaIdUsuaCdUsuario.value > 0">

                              <div style="width: 100%;" >
                                <!-- <div style="float: left; width: 69%; margin-top:5px ;">
                                  <button mat-raised-button type="button" (click)="loadDialogPermissoes(formulario.controls.usuaIdUsuaCdUsuario.value, formulario.controls.re.value, formulario.controls.nome.value)"
                                    style="margin-top: 15px; background-color: rgb(85, 114, 125); color: #fff; width: 99%;font-size: 12px ">
                                    Permissões
                                  </button>
                                </div> -->

                                <div style="float: left; width: 69%; margin-top:5px; vertical-align: middle;">
                                  <button *ngIf="!isRevogado" mat-raised-button type="button" (click)="revogarSenha()"
                                    style="margin-top: 15px; background-color: rgb(255, 174, 0); color: #fff; width: 99%;font-size: 12px ">
                                    Revogar senha
                                  </button>
                                  <div *ngIf="isRevogado" style="width: 100%; color: red; text-align: center; margin-top: 15px;" >
                                      Senha revogada, solicitar atualização na tela de login!
                                  </div>
                                </div>

                                <div style="float: left; width: 30%; margin-top:5px ;">
                                  <button mat-raised-button type="button" (click)="loadDialogEmpresas(formulario.controls.usuaIdUsuaCdUsuario.value, formulario.controls.re.value, formulario.controls.nome.value)"
                                    style="margin-top: 15px; background-color: rgb(85, 114, 125); color: #fff; width: 99%;  font-size: 12px ">
                                    Vincular outras operações
                                  </button>
                                </div>
                              </div>

                              <div style="width: 100%; ">

                                <div style="float: left; width: 69%; margin-top:5px ;">
                                  <button mat-raised-button  type="button" (click)="add()"
                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px">
                                    Salvar
                                  </button>
                                </div>

                                <div style="float: left; width: 30%;  margin-top:5px ; ">
                                  <button mat-raised-button color="warn" type="button" (click)="clearFormulario()"  style="color: #fff; width: 99%; font-size: 12px ">
                                    Cancelar
                                  </button>
                                </div>
                              </div>

                            </div>


                        </div>
                    </div>
                </mat-card>
                <br/>
              </div>



            <!--DIV DIREITA-->
            <!--container ajustado dinamicamente-->
            <div id="formAndList" style="margin-left: 10px;">


              <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                <div style=" margin-left: 15px; font-size: 14px;">Lista de usuários (Funcionários)</div>
              </div>
              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                <mat-card class="mat-elevation-z8" style="padding: 8px;">


                    <!--container ajustado dinamicamente-->
                    <div id="subDivContainer" style="width: 100%; ">
                        <div id="subDivAdjustAutoHeight" style="overflow-y: auto; font-size: 12px;">

                          <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                            <mat-form-field class="example-full-width">
                              <mat-label>Buscar na lista </mat-label>
                              <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                            </mat-form-field>
                          </div>


                          <table mat-table [dataSource]="dataSource" matSort #sortUsuario="matSort"
                              class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                              <!-- Symbol Column -->
                              <ng-container matColumnDef="usuaNmUsuario" >
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:40%;"> Nome </th>
                                <td mat-cell *matCellDef="let element" (click)="setFormUsuario(element)" style="width:40%; cursor: pointer;">
                                  {{element.usuaNmUsuario}}
                                </td>
                              </ng-container>

                              <!-- Name Column -->
                              <ng-container matColumnDef="usuaDsRe">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> RE </th>
                                <td mat-cell *matCellDef="let element"  (click)="setFormUsuario(element)" style="width:30%; cursor: pointer;"> {{element.usuaDsRe}} </td>
                              </ng-container>

                              <!-- Symbol Column -->
                              <ng-container matColumnDef="usuaDhInativo" >
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> Inativo </th>
                                  <td mat-cell *matCellDef="let element" (click)="setFormUsuario(element)" style="width:30%; cursor: pointer;"> {{element.usuaDhInativo == null ? 'NÃO' : 'SIM'}} </td>
                              </ng-container>


                              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 15px;"></tr>
                              <tr mat-row *matRowDef="let row; columns: displayedColumns; " class="aoPassarMouse" style="height: 10px;"></tr>
                            </table>

                        </div>
                    </div>
                </mat-card>

              </div>






              </div>

            </div>

          </div>

        </div>
      </form>
  </mat-tab>

  <mat-tab *ngFor="let number of [1];let i=index;" label="📝 Permissões " >

    <div style="height: 680px;">
      **** permisões liberadas na edição do usuário ****
    </div>

  </mat-tab>

</mat-tab-group>



</div>
